import styled from 'styled-components';

export const LegalContainer = styled.div`
  width: 80%;
  margin: 0 auto;
  margin-bottom: 1rem;
  color: white;
  font-family: Roboto, sans-serif;

  table, td {
    border: 1px solid white;
  }

`;
